import { NewPasswordForm } from "@/entities/new-password-form";
import { useNewPasswordForm } from "@/features/password-recovery/model/hooks";

export const NewPasswordStep = () => {
  const props = useNewPasswordForm();

  return <NewPasswordForm {...props} />;
};
